import {
  DELETE_PAYMENT_INFO,
  DELETE_INTEGRATION_SETTINGS,
  DELETE_TREKKSOFT_CATEGORIES,
  RESET_DELETED_INTEGRATION_SETTINGS
} from 'constants/userSettings';

export const deletePaymentInfo = (id, paymentSystem) => {
  return { type: DELETE_PAYMENT_INFO, id, paymentSystem };
};

export const deleteIntegrationSettings = (id, integrationPlatform) => {
  return { type: DELETE_INTEGRATION_SETTINGS, id, integrationPlatform };
};

export const resetDeletedIntegrationSettings = () => {
  return { type: RESET_DELETED_INTEGRATION_SETTINGS };
};

export const deleteTrekksoftCategory = id => {
  return { type: DELETE_TREKKSOFT_CATEGORIES, id };
};
